
CustomTC.define('text!modules/recast/htmls/remove-recast.html',[],function () { return '<div class="removeNewreCast tcNewreCastWrapper hide hide767">\r\n\t<div class="tcNewreCastFooter"> <span id="removeReCast">Remove reCast</span> </div>\r\n</div>';});

